/**
 * 知识库首页 /kb 内存缓存（SPA 内有效）。
 * 再次进入时先展示上次数据，后台再拉最新。
 */

let cache = null

export function getKbIndexCache() {
  if (!cache) return null
  return {
    categories: cache.categories.map((c) => ({ ...c })),
    recommendedSeries: cache.recommendedSeries.map((s) => ({ ...s }))
  }
}

export function setKbIndexCache(categories, recommendedSeries) {
  cache = {
    categories: Array.isArray(categories) ? categories.map((c) => ({ ...c })) : [],
    recommendedSeries: Array.isArray(recommendedSeries)
      ? recommendedSeries.map((s) => ({ ...s }))
      : []
  }
}
